module.exports = __webpack_public_path__ + "img/0xCa3F508B8e4Dd382eE878A314789373D80A5190A.b202b202.png";